import React from 'react';
import { setClassNames } from '@ddc/classnames-js';
import { useSelector } from 'react-redux';
import { useLabels, usePrefs } from 'wsm-common-data';

const VehiclePrice = () => {
	const { vehiclePriceClasses } = usePrefs();

	const { price } = useSelector((state) => state.vehicleData);
	const labels = useLabels();
	const vehiclePriceClassNames =
		vehiclePriceClasses.length > 0
			? vehiclePriceClasses.split(' ')
			: ['spacing-reset'];
	return (
		<p className={setClassNames(vehiclePriceClassNames)}>
			{`${labels.get('STARTING_AT')} ${price}`.trim()}
		</p>
	);
};

export default VehiclePrice;
